module.exports = __webpack_public_path__ + "static/Limbix-e9a372d3019969d88383cb65fc762193.jpg";